import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRight = (props, ref) => <svg width={24} height={24} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}><path d="M16 12L10 15.4641L10 8.5359L16 12Z" /></svg>;
const ForwardRef = forwardRef(SvgArrowRight);
export default ForwardRef;